import { ERROR_TYPE, getAllErrors } from "@/utils/errors";
import { requestFailureReason } from "@/utils/describeSaveFailure";

/**
 * What the Sales Navigator preview shows when it cannot show results: the access problem the form
 * already translated, else the reason the API gave for refusing the preview (verbatim: e.g. that
 * the planned scraping user is not a member of the workspace), else the form's own errors.
 * The API's sentence used to go through getAllErrors, which maps any message that is not a known
 * code to SOMETHING_WRONG (PREC-4626).
 */
export function previewFailureMessage(
	accessMessage: string | undefined,
	previewError: unknown,
	formErrors: ERROR_TYPE[]
): string | undefined {
	if (accessMessage) {
		return accessMessage;
	}

	const reason = requestFailureReason(previewError);

	if (reason) {
		return reason;
	}

	const allErrors = getAllErrors(undefined, formErrors);

	return allErrors.length ? allErrors.join(", ") : undefined;
}
